import React from "react";
// outsource
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

const PayoutReportChart = ({ reportData, formatMoney }) => {
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <div className="payout-report-chart-card">
        <ResponsiveContainer width="100%" height={390}>
          <PieChart margin={{ top: 20, right: 40, bottom: 20, left: 40 }}>
            <Pie
              data={reportData}
              dataKey="totalPayout"
              nameKey="code"
              cx="50%"
              cy="45%"
              innerRadius={85}
              outerRadius={160}
              paddingAngle={0}
              labelLine={false}
              className="payout-report-pie-chart-card"
              label={({ payload }) => `${payload.reportPercent.toFixed(1)}%`}
            >
              {reportData.map((entry) => (
                <Cell key={entry.id} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip
              formatter={(value, name) => [`$${formatMoney(value)}`, name]}
            />
          </PieChart>
        </ResponsiveContainer>
        <div className="payout-report-legend">
          {reportData.map((item) => (
            <div className="payout-report-legend-item" key={item.id}>
              <span
                className="payout-report-legend-dot"
                style={{ backgroundColor: item.color }}
              />
              <span>{item.code}</span>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // -------------------------- MAIN --------------------------
  return renderBody();
};

export default PayoutReportChart;
